<template>
  <div id="content">
    <div class="page-title">常见问题
      <div style="height: 8px"></div>
    </div>
    <div divalign="center" style="font-size: 16px">
      <div class="page-title1">亮屏时间无法设置
        <div style="height: 8px"></div>
      </div>
      <p class="page-title2">点击亮屏时间后，提示【设备省电运行中，请上线再试！】，表示当前设备处于省电状态</p>
      <img src="./brightscreentime/lp1.png" class="bg"/>
      <p class="page-title2">亮屏时间设置步骤:</p>
      <p class="page-title2">1. 按一下门铃</p>
      <p class="page-title2">2. APP查看设备状态由【省点运行中 】更新为【实时视频】</p>
      <p class="page-title2">3. 【实时视频】状态下进入设置可进行亮屏时间设置</p>
      <img src="./brightscreentime/lp2.png" class="bg"/>
      <img src="./brightscreentime/lp3.png" class="bg"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'no_bind'
  }
</script>

<style scoped>
  .page-title {
    font-size: 18px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    border-width: 0 0 1px 0;
    font-family:blod  黑体 ;
    font-weight:900;
    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title1 {
    font-family:blod  黑体 ;
    font-weight:100;

    font-size: 18px;
    margin: 20px auto;
    line-height: 1;
    left: 14px;
    border-width: 0 0 1px 0;

    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title2 {
    left: 14px;
    height: 26px;
    font-family: 简体;
    font-size: 16px;
    color: #666666;
  }

  .bg {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonproblem/brightscreentime/brightscreentime.vue